"use client"

import { useToast } from "@/ui/components/Toast/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/ui/components/Toast/toast"
import { Icon } from "@/ui/atoms/Icon"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, duration, icon, ...props }) {
        return (
          <Toast key={id} duration={duration ?? 5000} {...props}>
            <div className="flex gap-2 font-body pb-4">
              <div>
              {icon && <Icon name={icon} className="text-orange-50 mt-[1px]"/>}
              </div>
              <div className="flex flex-col gap-2">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
